import { useQuery } from '@tanstack/react-query';

import { catalogQuery } from '../catalogQuery';

/**
 * Every library item, with this workspace's state on each.
 *
 * One request, because the service answers state per workspace in the same
 * door (spec 104 research R1). What it asks and what it stores live in
 * `catalogQuery`, which is shared with the board's missing-parts warning —
 * see the comment there for why that sharing is not optional.
 */
export function useLibraryItems(workspaceId: string) {
  const query = useQuery({
    ...catalogQuery(workspaceId),
    // The answer depends on the workspace's files and workflows, which change
    // on other pages (a skill's folder deleted on the Files page, a workflow
    // removed) without anything here hearing about it. The app's default
    // minute of freshness would show "installed" for something that is gone,
    // so every visit re-reads, and so does returning to the window.
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
  });

  return {
    items: query.data?.items ?? [],
    unavailable: query.data?.unavailable === true || query.isError,
    isPending: query.isPending,
    refetch: query.refetch,
  };
}
